import AppSettings from '../AppSettings';
import * as api from '../net/api';
import CanvasObject from './CanvasObject';
import { CANVAS_ACTIONS } from './canvasActionTypes';
import { roundRect, allInside } from './canvas-helper';
import RedCros from '../../img/red-cross.png';
import '../../core/lib/canvasToBlob';
import { MONOGRAM } from './itemTypes';

function convertFont(fontStyle = {}) {
	const { height, name } = fontStyle;
	let font = `${height}px ${name}`;
	if (fontStyle.bold) {
		font = 'bold ' + font;
	}
	if (fontStyle.italic) {
		font = 'italic ' + font;
	}
	return font;
}

function measureTextWidth(text, fontStyle, canvasContext) {
	canvasContext.font = convertFont(fontStyle);
	canvasContext.textAlign = 'left';
	return canvasContext.measureText(text).width;
}

function addDebugMarker(ctx,x,y,colour) {

	if(!AppSettings.isLocal()) return;

	ctx.save();
	ctx.strokeStyle = colour;
	roundRect(ctx, x - 5, y - 5, 10, 10, 1);
	ctx.restore();
}

class MonogramItem extends CanvasObject {

	constructor( text, ctx, options = {}) {


		super();

		this.ctx = ctx;

		//this.bleeding = options.bleeding || 3;
		this.baseLine = 0; //10;
		this.coords = options.coordinates;
		this.coverageArea = options.coverageArea;
		this.templateArea = options.allowedArea;
		this.layerType = options.layerType;
		this.canvasScale = options.canvasScale;

		//allow for portrait mode -----------------------
		this.coverageArea = {
			x: options.coverageArea.x,
			y: options.coverageArea.y,
			width: (options.isPortrait)? options.coverageArea.height : options.coverageArea.width,
			height: (options.isPortrait)? options.coverageArea.width : options.coverageArea.height
		}

		this.width = 80; //90; //this.coverageArea.width; 
		this.height = 80; //this.coverageArea.height;


		this.type = MONOGRAM;

		this.scaledSize = Math.floor(25 * this.canvasScale); //25 is default

		this.fontStyle = options.fontStyle || {
			name: defaultFont, // Arial, Helvetica
			height: this.scaledSize,
			color: localStorage.getItem('colors') ? localStorage.getItem('colors') : currentColor,
		};
		this.maxWidth = options.coverageArea.width;

		//this.height = +this.fontStyle.height + this.baseLine;
		//this.width = measureTextWidth(text, this.fontStyle, this.ctx); //cf test

		this.selected = true;
		this.rotation = 0;

		this.setText(text);
		this.testCoverage();

		this.borderColor = options.borderColor || 'rgb(49, 183, 219)';  //line colour for handles container

		this.removed = false;

		const removedIcon = new Image();
		removedIcon.src = RedCros;
		removedIcon.onload = () => {
			this.removedIcon = removedIcon;
		};

	}

	setText(text) {
		this.text = text;

		this.originPoint = {
			x: (this.coverageArea.x + this.coverageArea.width)/2 - this.width/2, 
			y: (this.coverageArea.y + this.coverageArea.height)/2 - this.height/2 
		};

	}

	setFontSize(font_style,size) {
		this.fontStyle = font_style; 
		this.fontStyle.height = +size;
	}

	setFontStyle(font_style) {

		this.fontStyle = font_style;
		
		this.height = Math.floor(this.canvasScale * this.fontStyle.height + this.baseLine);
	}

	getFontStyle() {
		return Object.assign({}, this.fontStyle);
	}

	render(ctx) {
		if (!this.text) {
			return;
		}

		const { width, height } = ctx.canvas;

		const canvasCenter = {
			x: width / 2,
			y: height / 2
		};

		addDebugMarker(ctx, canvasCenter.x, canvasCenter.y, '#ff0000' );  //marks canvas actual centre

		//draw coverage area ------------------------------------------
		if (this.selected) {
			ctx.save();
			ctx.translate(canvasCenter.x, canvasCenter.y); //move ctx originpoint to canvasCenter
			ctx.strokeStyle = '#000000';
			roundRect(ctx, this.coverageArea.x, this.coverageArea.y, this.coverageArea.width, this.coverageArea.height, 0); //draw rect relative to ctx originPoint (= canvasCenter)
			ctx.restore();
		}

		ctx.save();


		ctx.translate(this.originPoint.x + canvasCenter.x, this.originPoint.y + canvasCenter.y);
		//ctx.translate(this.originPoint.x + canvasCenter.x - this.width/2, this.originPoint.y + canvasCenter.y);

		addDebugMarker(ctx, canvasCenter.x, canvasCenter.y, '#ffffff' ); 
		addDebugMarker(ctx, 0, 0, '#ffff00' ); //marks item actual centre = ctx.originPoint

		//handles (drawn relative to this.originPoint) --------------------------------------
		if (this.selected) {
			ctx.strokeStyle = this.borderColor;

			//use ctx.linewidth to control stroke thickness
			//use ctx.stokeStyle = rgba(~colour params, alpha param~) for translucent line

			roundRect(ctx, -this.width / 2, -this.height / 2, this.width, this.height, 2);

			// show border of item
			// draw left top corner
			ctx.beginPath();
			ctx.arc(-this.width / 2, -this.height / 2, 5, 0, 2 * Math.PI);
			ctx.fillStyle = this.hoverCorners.leftTop ? this.borderColor : 'white';
			ctx.fill();
			ctx.stroke();

			// draw right top corner
			ctx.beginPath();
			ctx.arc(this.width / 2, -this.height / 2, 5, 0, 2 * Math.PI);
			ctx.fillStyle = this.hoverCorners.rightTop ? this.borderColor : 'white';
			ctx.fill();
			ctx.stroke();

			//draw left bottom corner
			ctx.beginPath();
			ctx.fillStyle = this.hoverCorners.leftBottom ? this.borderColor : 'white';
			ctx.arc(-this.width / 2, this.height / 2, 5, 0, 2 * Math.PI);
			ctx.fill();
			ctx.stroke();

			//draw right bottom corner
			ctx.beginPath();
			ctx.arc(this.width / 2, this.height / 2, 5, 0, 2 * Math.PI);
			ctx.fillStyle = this.hoverCorners.rightBottom ? this.borderColor : 'white';
			ctx.fill();
			ctx.stroke();

		}

		//? shouldn't this section be inside the 'is selected' closure?

		if (this.flipped) {
			ctx.scale(-1, 1);
		}

		ctx.font = convertFont(this.fontStyle);
		
		if(this.coords){
			ctx.beginPath();
			let data = this.text.split('')
			ctx.fillStyle = this.fontStyle.color;
			var itemCentre = {x:Math.floor(this.width/2), y:Math.floor(this.height/2) };
			
			ctx.textAlign = "right";
			ctx.font = `${data[0] ? `${this.coords.a.fontSize * 1.5}px ${this.fontStyle.name}` : ""}`;
			ctx.fillText(data[0] ? data[0] : "", this.coords.a.x - itemCentre.x , this.coords.a.y - itemCentre.y + 15);  //15 is temp workaround to centre vertically. Need a method to work out the correct value based on ctx height.
			ctx.textAlign = "center";
			ctx.font = `${data[1] ? `${this.coords.b.fontSize * 1.5}px ${this.fontStyle.name}` : ""}`;
			ctx.fillText(data[1] ? data[1] : "", this.coords.b.x - itemCentre.x, this.coords.b.y - itemCentre.y + 15);
			ctx.textAlign = "left";
			ctx.font = `${data[2] ? `${this.coords.c.fontSize * 1.5}px ${this.fontStyle.name}` : ""}`;
			ctx.fillText(data[2] ? data[2] : "", this.coords.c.x - itemCentre.x, this.coords.c.y- itemCentre.y + 15);

		}
		else {
			ctx.beginPath();
			ctx.fillStyle = this.fontStyle.color;
			ctx.fillText(this.text, -this.width / 2, this.height / 2 - 2, this.width, this.maxWidth);
		}

		//addDebugMarker(ctx, 0, 0, '#ffff00' ); //marks item actual centre = ctx.originPoint
		//addDebugMarker(ctx, itemCentre.x, itemCentre.y, '#00ff00' ); //marks coverage actual centre!?


		ctx.restore();

		if (this.removed && this.removedIcon) {

			ctx.save();

			const { x, y } = this.originPoint;
			ctx.translate(x + canvasCenter.x, y + canvasCenter.y);
			if (this.rotation !== 0) {
				ctx.rotate(this.rotation * Math.PI / 180);
			}

			ctx.beginPath();
			ctx.fillStyle = 'rgba(200,200,200, 1)';
			ctx.arc(-this.width / 2, -this.height / 2, 10, 0, 2 * Math.PI);
			ctx.fill();

			ctx.drawImage(this.removedIcon, -this.width / 2 - 5, -this.height / 2 - 5, 10, 10);

			ctx.restore();
		}
	}
	// render end ---------------------------------------------------------------------------------------------------

	hover(pos) {
		super.hover(pos);
		if (this.action === CANVAS_ACTIONS.SCALING_ROTATION) {
			this.fontStyle.height = this.height - this.baseLine;
		}
	}

	hitTest(pos) {
		return (pos.x >= this.originPoint.x - this.width / 2
			&& pos.x <= this.originPoint.x + this.width / 2
			&& pos.y >= this.originPoint.y - this.height / 2
			&& pos.y <= this.originPoint.y + this.height / 2)
			|| (this.hoverCorners.leftTop
				|| this.hoverCorners.leftBottom
				|| this.hoverCorners.rightTop
				|| this.hoverCorners.rightBottom
				|| this.hoverCorners.rotatePoint
			);
	}

	testCoverage() {
		const vertices = [this.getLeftBottomCorner(),
		this.getRightTopCorner(),
		this.getLeftTopCorner(),
		this.getRightBottomCorner()];
		this.errorCoverage = !allInside(vertices, this.coverageArea);

		let itemMargin = 8; //account for margin between text and the handle-box;

		this.removed = 
			   this.originPoint.x + this.width / 2 < this.templateArea.x + itemMargin
			|| this.originPoint.x - this.width / 2 > this.templateArea.x + this.templateArea.width - itemMargin
			|| this.originPoint.y + this.height / 2 < this.templateArea.y + itemMargin
			|| this.originPoint.y - this.height / 2 > this.templateArea.y + this.templateArea.height - itemMargin;


		// Show info message about delete the selected items
		//const info = document.querySelector("#info-message");
		const info = document.querySelector("#feature-info-message");
		
		if (!this.removed) {
			info.classList.add('show');
		} else {
			info.classList.remove('show');
		}

		return this.errorCoverage;
	}

	handleResize(scale) {
		//const ratio = this.width / this.height;


		this.width *= scale;
		this.fontStyle.height *= scale;

		const newHeight = this.fontStyle.height + this.baseLine * scale;
		const newWidth = measureTextWidth(this.text, this.fontStyle, this.ctx);


		const scaleWidth = this.width / newWidth;
		const scaleHeight = this.height / newHeight;

		this.originPoint = {
			x: this.originPoint.x * scale,
			y: this.originPoint.y * scale
		};

		//this.width = newWidth;
		//this.height = newHeight;

		this.coverageArea.x *= scale;
		this.coverageArea.y *= scale;
		this.coverageArea.width *= scale;
		this.coverageArea.height *= scale;
	}

	preview(scale, ctx) {

		const { width, height } = ctx.canvas;

		const canvasCenter = {
			x: width / 2,
			y: height / 2
		};

		const item = {
			text: this.text,
			fontStyle: { ...this.fontStyle },
			width: this.width * scale.width,
			height: this.height * scale.height,
			rotation: this.rotation,
			flipped: this.flipped,
			originPoint: {
				x: this.originPoint.x * scale.width,
				y: this.originPoint.y * scale.height
			},
			maxWidth: this.maxWidth * scale.width
		};

		// item.fontStyle.height *= scale.height;
		// item.height = item.fontStyle.height + this.baseLine * scale.height;

		ctx.save();
		ctx.translate(item.originPoint.x + canvasCenter.x, item.originPoint.y + canvasCenter.y);
		if (item.rotation !== 0) {
			ctx.rotate(item.rotation * Math.PI / 180);
		}

		if (item.flipped) {
			ctx.scale(-1, 1);
		}

		ctx.font = convertFont(item.fontStyle);

		ctx.textAlign = 'left';
		ctx.textBaseline = 'bottom';

		if (item.fontStyle.shadow) {
			ctx.beginPath();
			ctx.fillStyle = 'rgba( 0,0,0,.4)';
			ctx.fillText(item.text, -item.width / 2 + 3, item.height / 2 - 1, item.width, item.maxWidth);
		}

		if (item.fontStyle.stroke) {

			ctx.beginPath();
			ctx.strokeStyle = item.fontStyle.color;
			ctx.strokeText(item.text, -item.width / 2, item.height / 2 - 2, item.width, item.maxWidth);

		} else {

			ctx.beginPath();
			ctx.fillStyle = item.fontStyle.color;
			ctx.fillText(item.text, -item.width / 2, item.height / 2 - 2, item.width, item.maxWidth);
		}
		ctx.restore();
	}

	getCustomImage(size, scale) {

		const textCanvas = document.createElement('canvas');
		const textCanvasContext = textCanvas.getContext('2d');

		textCanvas.width = size.width;
		textCanvas.height = size.height;

		// render text on actual card size
		this.preview(scale, textCanvasContext);


		const canvasCenter = {
			x: textCanvas.width / 2,
			y: textCanvas.height / 2,
		};

		console.log('center', canvasCenter);

		const rect = this.getBoundRect(scale);

		const area = {
			x: canvasCenter.x + rect.left * scale.width,
			y: canvasCenter.y + rect.top * scale.height,
			width: (rect.right - rect.left) * scale.width,
			height: (rect.bottom - rect.top) * scale.height
		};

		console.log('area', area);

		// crop image to actual size
		const croppedCanvas = document.createElement('canvas');
		const croppedContext = croppedCanvas.getContext('2d');

		croppedCanvas.width = area.width;
		croppedCanvas.height = area.height;

		croppedContext.drawImage(textCanvas, area.x, area.y, area.width, area.height, 0, 0, area.width, area.height);

		return new Promise(resolve => croppedCanvas.toBlob(data => resolve(data)));
	}


	async uploadCustomImage(size, scale) {

		const imageData = this.getCustomImage(size, scale);
		if (imageData) {

			const res = await api.uploadCustomImage(AppSettings.handoverKey, AppSettings.clientId, 1, imageData);

			if (res) {
				console.log('res', res);
				this.imageId = res.Id;
			}
		}

	}

}

export default MonogramItem;